export default "__VITE_ASSET__CyTgZdi5__"